export default function componentStyleOverrides(theme) {
    return {
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding: 0,
                    overflow: 'auto'
                }
            }
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: 0,
                    overflow: 'auto'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '25px',
                    height: '45px'
                }
            },
            variants: [
                {
                    props: { variant: 'round' },
                    style: {
                        height: '45px',
                        width: '45px',
                        minWidth: 'auto',
                        borderRadius: '50%',
                        border: `2px solid ${theme.colors.primaryNeutral}`,
                        ':hover': {
                            backgroundColor: theme.colors.secondaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.secondaryMain}`,
                        }
                    }
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        color: 'black',
                        border: `2px solid ${theme.colors.primaryNeutral}`,
                        ':hover': {
                            backgroundColor: theme.colors.secondaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.secondaryMain}`,
                        },
                        '&.active': {
                            backgroundColor: theme.colors.secondaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.secondaryMain}`,
                        }
                    }
                },
                {
                    props: { variant: 'square' },
                    style: {
                        backgroundColor: theme.colors.secondaryMain,
                        color: '#FFF',
                        border: `2px solid ${theme.colors.secondaryMain}`,
                        borderRadius: '5px',
                        ':hover': {
                            backgroundColor: theme.colors.primaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.primaryMain}`,
                        },
                        '&.active': {
                            backgroundColor: theme.colors.secondaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.secondaryMain}`,
                        }
                    }
                },
                {
                    props: { variant: 'outlined blue' },
                    style: {
                        color: 'black',
                        border: `2px solid ${theme.colors.primaryMain}`,
                        ':hover': {
                            backgroundColor: theme.colors.primaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.primaryMain}`,
                        },
                        '&.active': {
                            backgroundColor: theme.colors.primaryMain,
                            color: '#FFF',
                            border: `2px solid ${theme.colors.primaryMain}`,
                        }
                    }
                },
            ]
        },

        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '0'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    alignItems: 'center'
                },
                outlined: {
                    border: '1px dashed'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '9px',
                    paddingBottom: '9px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack,
                            borderColor: theme.colors.secondaryMain,
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    border: 'none',
                    '&::placeholder': {
                        color: theme.textDark,
                        fontSize: '0.875rem'
                    }
                },   
            }
        },
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    fontSize: '14px',
                    fontWeight: 300
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    lineHeight: '16px',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: 'transparent',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: `2px solid ${theme.colors.grey200}`,
                    },            
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    },                    
                },
                input: {
                    fontWeight: 500,
                    background: 'transparent',
                    padding: '13.5px 14px',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },  
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme?.customization?.navType === 'dark' ? theme.colors.darkTextPrimary + 50 : theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.customization?.navType === 'dark' ? theme?.colors?.primaryMain : theme?.colors?.primaryLight
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiAutocomplete-tag': {
                        background:
                            theme?.customization?.navType === 'dark' ? theme.colors.darkTextPrimary + 20 : theme.colors?.secondaryLight,
                        borderRadius: 4,
                        color: theme.textDark,
                        '.MuiChip-deleteIcon': {
                            color: theme?.customization?.navType === 'dark' ? theme.colors.darkTextPrimary + 80 : theme.colors?.secondary200
                        }
                    }
                },
                popper: {
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    boxShadow: '0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)'
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: theme?.customization?.navType === 'dark' ? 0.2 : 1
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    '&:focus': {
                        backgroundColor: 'transparent'
                    }
                },
                variants: [
                    {
                        props: { variant: 'outlined' },
                        style: {
                            color: 'black',
                            padding: '15px'
                        }
                    },
                ]                
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme?.customization?.navType === 'dark' ? theme.colors?.darkLevel1 : theme.colors?.primaryDark,
                    background: theme?.customization?.navType === 'dark' ? theme.darkTextPrimary : theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTimelineContent: {
            styleOverrides: {
                root: {
                    color: theme.textDark,
                    fontSize: '16px'
                }
            }
        },
        MuiTreeItem: {
            styleOverrides: {
                label: {
                    marginTop: 14,
                    marginBottom: 14
                }
            }
        },
        MuiTimelineDot: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                }
            }
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    maxWidth: '1420px'
                }
            }
        },
        MuiInternalDateTimePickerTabs: {
            styleOverrides: {
                tabs: {
                    backgroundColor: theme?.customization?.navType === 'dark' ? theme.colors?.darkPaper : theme.colors?.primaryLight,
                    '& .MuiTabs-flexContainer': {
                        borderColor:
                            theme?.customization?.navType === 'dark' ? theme.colors?.darkTextPrimary + 20 : theme.colors?.primary200
                    },
                    '& .MuiTab-root': {
                        color: theme?.customization?.navType === 'dark' ? theme.colors?.darkTextSecondary : theme.colors?.grey900
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: theme.colors?.primaryDark
                    },
                    '& .Mui-selected': {
                        color: theme.colors?.primaryDark
                    }
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                flexContainer: {
                    borderBottom: '1px solid',
                    borderColor: theme?.customization?.navType === 'dark' ? theme.colors.darkTextPrimary + 20 : theme.colors?.grey200
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    padding: '12px 0 12px 0'
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: theme?.customization?.navType === 'dark' ? theme.colors.darkTextPrimary + 15 : theme.colors?.grey200,
                    '&.MuiTableCell-head': {
                        fontSize: '0.875rem',
                        color: theme.heading,
                        fontWeight: 500
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme?.customization?.navType === 'dark' ? theme.colors?.darkLevel1 : theme.paper,
                    background: theme?.customization?.navType === 'dark' ? theme.colors?.grey50 : theme.colors?.grey700
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontSize: '1.25rem'
                }
            }
        }
    };
}
